/**
 * Rodzaj kryterium
 *
 * @export
 * @enum {number}
 */
export enum CriterionType {
  /**
   * Kryterium typu Tak/Nie
   */
  BOOL = 'BOOL',

  /**
   * Kryterium z oceną punktową
   */
  SCORE = 'SCORE',

  /**
   * Kryterium sprawdzające sumaryczną liczbę punktów podkryteriów
   */
  SCORE_CONTAINER = 'SCORE_CONTAINER'
}

export const CriterionTypeTranslation = {
  [CriterionType.BOOL]: 'Ocena typu Tak/Nie',
  [CriterionType.SCORE]: 'Ocena punktowa',
  [CriterionType.SCORE_CONTAINER]: 'Sumaryczne'
};

export const CriterionTypeList = [
  { value: CriterionType.BOOL, text: CriterionTypeTranslation[CriterionType.BOOL] },
  { value: CriterionType.SCORE, text: CriterionTypeTranslation[CriterionType.SCORE] },
  { value: CriterionType.SCORE_CONTAINER, text: CriterionTypeTranslation[CriterionType.SCORE_CONTAINER] }
];
